import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 41000-41999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const cad2pdfErrors = {
  // 41xxx-50xxx closes out the long tail of small modules. Each block below is one module; several
  // needed only one or two codes because their remaining sites either reused an existing code
  // verbatim, literally say "Something went wrong", or interpolate a runtime value and keep the
  // standing dynamic-message deferral.
  //
  // 41xxx cad2pdf. Its "File version not found." site reused FILE_VERSION_NOT_FOUND (25001).
  CAD2PDF_NOT_AVAILABLE: {
    errorCode: 41001,
    errorMessage: t("CAD to PDF conversion is not available on this server."),
    isDynamic: false,
  },
  CAD2PDF_NO_DRAWING_SPECIFIED: {
    errorCode: 41002,
    errorMessage: t("No drawing was specified to convert."),
    isDynamic: false,
  },
  CAD2PDF_CONVERSION_FAILED: {
    errorCode: 41003,
    errorMessage: t("The drawing could not be converted to PDF."),
    isDynamic: false,
  },
  CAD2PDF_EXTENSION_UNSUPPORTED: {
    errorCode: 41004,
    errorMessage: t("{{extension}} drawings cannot be converted. Only .dwg and .dxf are supported."),
    isDynamic: true,
    dynamicParams: ["extension"],
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
